export default {
  name: 'TableSlot',
  functional: true,
  inject: ['tableRoot'],
  props: {
    row: Object,
    index: Number,
    column: {
      type: Object,
      'default': null
    }
  },
  render: function render(h, ctx) {
    var cellSlot = ctx.injections.tableRoot.$scopedSlots[ctx.props.column.slot];
    if (typeof cellSlot === 'function') {
      return h('div', cellSlot({
        row: ctx.props.row,
        column: ctx.props.column,
        index: ctx.props.index
      }));
    }
    return null;
  }
};